import MileageStatus from "../../../types/mileage-status";
import VehicleType from "../../../types/vehicle-type";

export enum MileageListParamsOrder {
  DATE_ASC = "DATE_ASC",
  DATE_DESC = "DATE_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  WORKER_NAME_ASC = "WORKER_NAME_ASC",
  WORKER_NAME_DESC = "WORKER_NAME_DESC",
  WORKER_LAST_NAME_ASC = "WORKER_LAST_NAME_ASC",
  WORKER_LAST_NAME_DESC = "WORKER_LAST_NAME_DESC",
  CARD_NO_ASC = "CARD_NO_ASC",
  CARD_NO_DESC = "CARD_NO_DESC",
  DISTANCE_ASC = "DISTANCE_ASC",
  DISTANCE_DESC = "DISTANCE_DESC",
  CARGO_COMPANY_NAME_ASC = "CARGO_COMPANY_NAME_ASC",
  CARGO_COMPANY_NAME_DESC = "CARGO_COMPANY_NAME_DESC",
}

type MileageListParams = {
  page: number;
  pageSize: number;
  order?: MileageListParamsOrder;
  companyId?: string;
  dateSince?: Date;
  cargoCompanyName?: string;
  dateTo?: Date;
  humanId?: number;
  mileageNumber?: string;
  workerName?: string;
  cardNumber?: string;
  address?: string[];
  startAddress?: string[];
  midAddress?: string[];
  endAddress?: string[];
  distanceMax?: number;
  distanceMin?: number;
  vehicleType?: VehicleType;
  state?: MileageStatus;
};

export default MileageListParams;
